import { FormEvent, useEffect, useState } from "react";
import { api } from "../api";

type Flash = { kind: "ok" | "error"; text: string } | null;
type Props = { canManage: boolean; flash: (value: Flash) => void };
type Schedule = {
  competence: string; due_date: string | null; due_date_source: string | null;
  lead_days: number; search_from: string | null; enabled: boolean; company_ids: number[];
};
const previousMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
const initialMonth = `${previousMonth.getFullYear()}-${String(previousMonth.getMonth() + 1).padStart(2, "0")}`;
const displayDate = (value: string | null) => value ? value.split("-").reverse().join("/") : "Pendente";

export default function FgtsRulesPage({ canManage, flash }: Props) {
  const [month, setMonth] = useState(initialMonth);
  const competence = `${month.slice(5, 7)}/${month.slice(0, 4)}`;
  const [schedule, setSchedule] = useState<Schedule | null>(null);
  const [dueDate, setDueDate] = useState("");
  const [source, setSource] = useState("");
  const [leadDays, setLeadDays] = useState(5);
  const [saving, setSaving] = useState(false);

  async function load() {
    const result = await api<Schedule>(`/api/fgts-process?competence=${encodeURIComponent(competence)}`);
    setSchedule(result);
    setDueDate(result.due_date ?? "");
    setSource(result.due_date_source ?? "");
    setLeadDays(result.lead_days);
  }
  useEffect(() => { load().catch((error) => flash({ kind: "error", text: error.message })); }, [competence]);
  async function save(event: FormEvent) {
    event.preventDefault();
    setSaving(true);
    try {
      await api("/api/fgts-process", { method: "PUT", body: JSON.stringify({
        competence, due_date: dueDate, due_date_source: source, lead_days: leadDays, enabled: false,
      }) });
      await load();
      flash({ kind: "ok", text: "Regra do FGTS mensal salva para esta competência." });
    } catch (error) {
      flash({ kind: "error", text: error instanceof Error ? error.message : "Falha ao salvar regra" });
    } finally { setSaving(false); }
  }
  return <>
    <div className="page-head"><div><p className="eyebrow">REGRA DE BUSCA</p><h1>FGTS mensal</h1>
      <p>Defina a data efetiva da competência e quantos dias antes iniciar a consulta de GFD.</p>
    </div></div>
    <div className="notice">O vencimento mensal costuma ocorrer no dia 20 do mês seguinte, com antecipação quando não há expediente bancário. Informe a data efetiva publicada para cada competência. Guias rescisórias usam outro prazo e têm regra separada.</div>
    <section className="card darf-filters"><label>Competência
      <input type="month" value={month} onChange={(event) => setMonth(event.target.value)} />
    </label><div className="assignment-summary"><strong>Buscar a partir de {displayDate(schedule?.search_from ?? null)}</strong><span>{schedule?.company_ids.length ?? 0} empresas vinculadas ao FGTS Digital</span></div></section>
    <section className="card"><h2>Calendário da busca mensal</h2>
      <form className="form-grid" onSubmit={save}>
        <label>Vencimento efetivo<input type="date" required disabled={!canManage} value={dueDate} onChange={(event) => setDueDate(event.target.value)} /></label>
        <label>Iniciar quantos dias corridos antes<input type="number" min="0" max="31" required disabled={!canManage} value={leadDays} onChange={(event) => setLeadDays(Number(event.target.value))} /></label>
        <label className="wide">Fonte do vencimento<input type="url" required disabled={!canManage} value={source} onChange={(event) => setSource(event.target.value)} placeholder="Endereço da publicação oficial" /></label>
        <p className="wide muted">A busca do processo mensal será ativada depois da separação técnica das GFD rescisórias. A agenda atual permanece ativa até essa transição.</p>
        {canManage && <footer className="wide"><button className="primary" disabled={saving}>{saving ? "Salvando…" : "Salvar regra"}</button></footer>}
      </form>
    </section>
  </>;
}
